export default "__VITE_ASSET__D_5$zIul__"